import React from 'react';
import { useStaticQuery, graphql } from "gatsby"

const PreLoader = () => {
    const site_config = useStaticQuery(graphql`
    query siteConfigQuery{
        glstrapi {
            siteConfig {        
                Header_Logo {
                  url
                  alternativeText
                }
                Header_Bg_White_Logo{
                  url
                  alternativeText
                }
            }

        }
    }`)

    var site_config_var = site_config?.glstrapi?.siteConfig;
    var logo_var = site_config_var?.Header_Bg_White_Logo?.url ? site_config_var?.Header_Bg_White_Logo?.url : site_config_var?.Header_Logo?.url;

    return(
        <section className={"loader-wrapper"}>
            <div id="loader-wrapper">
                <div id="loader" className="new-loader">
                    <img className="logo-white" src={logo_var} alt="logo" />
                </div>
            </div>
        </section>
    )

}
export default PreLoader